/**
 * Redirect path returned to the user after Stripe Connect onboarding.
 * Backend prepends FRONTEND_URL when building Stripe return_url.
 */
export const APPLICATION_REDIRECT_PATHS = {
  dashboard: "/app/dashboard",
  browseOffers: "/app/browse-offers",
  reviewOffer: "/app/review-offer",
  submittedApplications: "/app/submitted-applications",
} as const;

export type ApplicationRedirectPath =
  (typeof APPLICATION_REDIRECT_PATHS)[keyof typeof APPLICATION_REDIRECT_PATHS];

export const getApplicationRedirectUrl = (
  path: ApplicationRedirectPath | string
): string => {
  return path.startsWith("/") ? path : `/${path}`;
};
